// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { gridSize, layers } from '@atlaskit/theme/constants';
import { N900, N200, N20, P300 } from '@atlaskit/theme/colors';
var GRID_UNIT = gridSize();
var _AkGrid = function AkGrid() {
  var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return {
    px: "".concat(num * GRID_UNIT, "px"),
    unitless: num * GRID_UNIT,
    multiple: function multiple(multiplier) {
      return _AkGrid(multiplier * num);
    },
    half: function half() {
      return _AkGrid(0.5 * num);
    },
    twice: function twice() {
      return _AkGrid(2 * num);
    }
  };
};
export var zIndex = {
  searchDialog: layers.dialog()
};
export var grid = _AkGrid(1);
export var atlassianNavigationHeight = '56px';
export var collapsedSearchInputWidth = '200px';
export var filterLabelWidth = '150px';
export var dialogWidth = '780px';
export var dialogPageTakeoverWidth = 780;
export var dialogPageCentreWidth = '1130px';
export var inputFieldHeight = grid.multiple(4);
export var enlargedInputFieldHeight = grid.multiple(6);
export var primaryTextColour = "var(--ds-text, ".concat(N900, ")");
export var itemLinkSecondaryColor = "var(--ds-text-subtlest, ".concat(N200, ")");
export var itemHighlightColor = "var(--ds-background-neutral-subtle-hovered, ".concat(N20, ")");
export var visitedLinkColor = "var(--ds-link-visited, ".concat(P300, ")");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var nowrapEllipsis = css({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
});